<template>
  <div>
    <div class="box">
      <div class="box-top">
        <p>统计列表</p>
        <div @click="isView=true" class="search-box">
          <span>筛选</span>
          <i class="iconfont">&#xe709;</i>
        </div>
      </div>
      <van-collapse v-model="activeUserID" v-if="dataList.length!==0">
        <van-collapse-item :name="index" v-for="(item,index) in dataList" :key="index"  @click.native="changeItem(item,index)">
          <div slot="title" class="title">
            <div style="display:flex;align-items: center;">
              <span class="index">{{index+1}}</span>
              <div class="class-group">
                <p class="name">{{item.ClassName}}</p>
                <p class="num">评价次数：{{item.EvaCount}}</p>
              </div>
            </div>
            <span class="avgScore">{{item.AvgScore}}<span>分</span></span>
          </div>
          <div @click.stop="stop">
            <div style="border-bottom: 1px dashed #eee;">
              <div :id="'pieOne'+index" style="height:300px;background:#fff;padding:10px;"></div>
            </div>
            <template>
              <div v-for="(item1) in item.pieList" :key="item1.idName">
                <div :id="item1.idName" style="height:300px;background:#fff;padding:10px;"></div>
              </div>
            </template>
          </div>
        </van-collapse-item>
      </van-collapse>
      <div v-else style="text-align: center;margin-top: 10px;">
        该搜索条件下没有结果。
      </div>
      <!-- <ul>
        <li v-for="(item,index) in dataList" :key="index"  @click.stop.prevent="changeItem(item,index)">
          <div class="title">
             <div style="display:flex;align-items: center;">
              <span class="index">{{index+1}}</span>
              <div class="class-group">
                <p class="name">{{item.ClassName}}</p>
                <p class="num">评价次数：{{item.EvaCount}}</p>
              </div>
            </div>
            <span class="avgScore">{{item.AvgScore}}<span>分</span></span>
          </div>
          <div style="border-bottom: 1px dashed #eee;">
            {{'pieOne'+index}}
            <div :id="'pieOne'+index" style="height:300px;background:#fff;padding:10px;"></div>
          </div>
          <div v-for="(item1) in item.pieList" :key="item1.idName">
            <div :id="item1.idName" style="height:300px;background:#fff;padding:10px;"></div>
          </div>
        </li>
      </ul> -->
    </div>
    <Search :isStatistics="false" :isView="isView" @listenToChildClose="close" @listenToChildCSubmit="submitSearch" />
  </div>
</template>
<script>
import Search from '@/pages/evaluation/views/classroomRecord/popupSearch.vue'
export default {
  components:{
    Search
  },
  data() {
    return {
      subjectStatistics:[],
      pieData:[],
      pie:{},
      activeUserID:[],
      isView: false,
      //学年
      isYearShow: false,
      selectYear: "",
      selectYearId: 0,
      yearData: [],
      //学期
      isSessionShow: false,
      selectSession: "",
      selectSessionId: 0,
      sessionData: [],
      dataList:[],
      startDate:'',
      endDate:'',
      echartsDom:'',
      activeIndex:0,
      activeFlag:[]
    }
  },
  created(){
    this.getYearData()
  },
  methods:{
    stop(){
      return false
    },
    changeItem(data,index){
      // 收起不请求
      if(this.activeUserID.length!==0){
        this.activeIndex=index
        this.activeUserID.forEach(item=>{
          if(item===index){
            this.getRingData(data)
            this.getpieData(data)
          }
        })
      }
    },
    // 指标分析
    getRingData (data) {
      this.xy.loading()
      this.xyapi.post(`${this.$store.state.apiPath}/api/MyEvaluationStatistics/GetOneStudentEvaluationStatisticsPie`, {
        SchoolDistrictID:data.SchoolDistrictID,
        StudentGradeForStudentYearID: data.StudentGradeForStudentYearID,
        DisciplineID:data.DisciplineID,
        // 条件筛选
        AcademicSessionID: this.selectSessionId,
        CoursePlan: {CoursePlanAID:data.CoursePlanAID,CoursePlanAIDType:data.CoursePlanAIDType},
        StarTime: this.startDate,
        EndTime:this.endDate
      }).then(res => {
        this.xy.unloading()
        if (res.success) {
          this.pieData = res.data
          let allData = []
          res.data.forEach(item => {
            allData.push({
              name: item.ObjectName,
              value: item.ObjectScore
            })
          })
          let option = {
            title: {
              text: '指标分析',
              textStyle: {
                fontSize: 15,
                fontColor: '#222222'
              }
            },
            tooltip: {
              trigger: 'item',
              // formatter: '{b}:{c} \n({d}%)'
              formatter: '{b}:{d}%',
              position: ['40%','40%']
            },
            series: [
              {
                type: 'pie',
                radius: ['20%', '40%'],
                data: allData,
                label: {
                  normal: {
                    // formatter: '{b}\n{c}次',
                    formatter: function(e){
                      if (e.name.length > 5) {
                        e.name =  e.name.slice(0,5) + '...';
                      }
                      return e.name+"\n"+e.value;
                    }
                  }
                }
              }
            ]
          }
          this.$nextTick(() => {
            this.pie = this.echarts.init(document.getElementById('pieOne'+this.activeIndex))
            this.pie.setOption(option,true)
          })
        }
      })
    },
    getpieData (data) {
      this.xy.loading()
      this.xyapi.post(`${this.$store.state.apiPath}/api/MyEvaluationStatistics/GetTwoStudentEvaluationStatistics`, {
        SchoolDistrictID:data.SchoolDistrictID,
        StudentGradeForStudentYearID: data.StudentGradeForStudentYearID,
        DisciplineID:data.DisciplineID,
        // 条件筛选
        AcademicSessionID: this.selectSessionId,
        CoursePlan: {CoursePlanAID:data.CoursePlanAID,CoursePlanAIDType:data.CoursePlanAIDType},
        StarTime: this.startDate,
        EndTime:this.endDate
      }).then(res => {
        this.xy.unloading()
        if (res.success) {
          let obj=res.data.map((item,index) => {
            const pie = {}
            let idName=''
            pie.data = item.Datas.map(item1 => {
              return {
                value: item1.ObjectScore,
                name: item1.ObjectName
              }
            })
            pie.ObjectName = item.ObjectName
            idName = "pie"+this.activeIndex+index
            return {
              pie: pie,
              idName
            }
          })
          this.$set(this.dataList[this.activeIndex],'pieList',obj)
          this.dataList[this.activeIndex].pieList.forEach(item=>{
            this.$nextTick(()=>{
              document.getElementById(item.idName) && this.setEchartPie(item.pie, this.echarts.init(document.getElementById(item.idName))) 
            })
          })
        }
      })
    },
    // 多个二级饼图
    setEchartPie (pie, echart) {
      let option = {
        title: {
          text: pie.ObjectName,
          textStyle: {
              fontSize: 15,
              fontColor: '#222222'
            }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
          position: ['40%','40%']
        },
        series: [
          {
            type: 'pie',
            radius: '40%',
            data: pie.data,
            label: {
              normal: {
                // formatter: '{b}\n{c}次',
                formatter: function(e){
                  if (e.name.length > 5) {
                    e.name =  e.name.slice(0,5) + '...';
                  }
                  return e.name+"\n"+e.value;
                }
              }
            }
          }
        ]
      }
      echart.setOption(option,true)
    },
    getYearData(){
      this.xy.loading();
      this.xyapi.get(`${this.xyMApi}/xy/comm/YearList`,).then(res=>{
        if(res.success){
          if (res.data.length > 0) {
            res.data.map(item => {
              if (item.IsCurrent) {
                this.selectYearId = item.ID
                this.selectYear = item.Name
                this.getSession(item.ID)
              }
              this.yearData.push({
                id: item.ID,
                name: item.Name
              })
            })
          }
        }
      })
    },
    //获取学期
    async getSession(id) {
      this.xy.loading();
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/SessionList`, {
        yearID: id
      })
      if (res.success) {
        this.selectSession = ""
        this.selectSessionId = 0
        this.sessionData = []
        res.data.map(item => {
          if (item.IsCurrent) {
            this.selectSessionId = item.AcademicSessionID;
            this.selectSession = item.AcademicSessionNam
            this.startDate=this.xy.moment(item.StartDate).format('YYYY-MM-DD')
            this.endDate=this.xy.moment(item.EndDate).format('YYYY-MM-DD')

          }
          this.sessionData.push({
            id: item.AcademicSessionID,
            name: item.AcademicSessionName
          })
        })
        this.getListData()//列表数据
      }
    },
    getListData(){
      this.xy.loading();
      this.xyapi.get(`${this.$store.state.apiPath}/api/IndexContrast/GetMobileStudentMyEvaList`,{
        academicYearID:this.selectYearId,
        AcademicSessionID:this.selectSessionId,
        StudentGradeForStudentYearID:0,
        StartDate:this.startDate,
        EndDate:this.endDate
      }).then(res=>{
        if(res.success){
          // res.data.forEach(item=>{
          //   this.$set(item,'pieList',[])
          // })
          this.dataList=res.data
        }
        if(this.dataList.length !==0){
          this.dataList.forEach(item=>{
            this.$set(item,'pieList',[{}])
          })
          this.activeUserID=[0]
          this.$nextTick(()=>{
            this.getRingData(this.dataList[0])//指标分析
            this.getpieData(this.dataList[0])//多个二级
          })
        }else{
          this.pieData=[]
          this.subjectStatistics=[]
          this.xy.unloading()
        }
      })
    },
    close(val){
      this.isView=val
    },
    submitSearch(val){
      this.isView=false
      this.selectYearId=val.AcademicYearID
      this.selectSessionId = val.academicSessionID;
      this.startDate=val.startDateText
      this.endDate=val.endDateText
      this.getListData()//列表数据
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .van-cell:not(:last-child):after{
  left:100px;
}
/deep/ .van-collapse-item{
  border-radius:  0 0 8px 8px;
}
/deep/ .van-collapse-item__content{
  padding:0;
}
.box-top{
  border-radius: 8px 8px 0 0;
  display: flex;
  height:100px;
  align-items: center;
  justify-content: space-between;
  padding:0 20px;
  background: #fff;
  // border-bottom: 1px solid #eee;
  p{
    font-size: 30px;
    color: rgba(34,34,34,1);
    margin-left: 15px;
    font-weight: 700;
  }
  .search-box{
    width:136px;
    height:64px;
    display: flex;
    align-items: center;
    justify-content: center;
    background:#fafafa;
    border:1px solid #dedede;
    border-radius: 32px;
    color:#606060;
    font-size: 28px;
    i{
      font-size: 30px;
    }
  }
}
.box-list{
  background: #fff;
  margin-top:20px;
  .list-wrap{
    border-bottom: 1px solid rgba(0,0,0,.1);
    .list-title{
        padding:20px;
        display: flex;
        align-items: center;
        img{
          width:42px;
          height:42px;
          margin-right:10px;
        }
      }
      .list-content{
        display: flex;
        justify-content: space-between;
        padding: 30px;
        div{
          text-align: center;
          p.text{
            margin-bottom:10px;
            font-size: 40px;
            color:rgba(0,0,0,.85);
          }
          p:nth-child(2){
            font-size: 24px;
            color:rgba(0,0,0,.45);
          }
        }
      }
  }
}
.box{
  padding:35px;
  /deep/ .van-cell .van-icon{
    margin-top:20px;
  }
  .index{
    background: rgba(245,245,245,1);
    color: rgba(102,102,102,1);
    width: 58px;
    height: 58px;
    border-radius: 50%;
    display: inline-block;
    line-height: 58px;
    text-align: center;
    margin-right:26px;
  }
  .title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    // background: #fff;
    // padding:15px 10px;
    // border-bottom: 1px solid #F0F0F0;
    .class-group{
      display: flex;
      flex-direction: column;
      .name{
        color:rgba(34,34,34,1);
        font-size: 28px;
      }
      .num{
        color:rgba(102,102,102,1);
        font-size: 26px;
      }
    }
  }
  .avgScore{
    font-size: 34px;
    color: rgba(255,96,16,1);
    span{
      font-size: 22px;
    }
  }
}
</style>
